export const RATES = {
    BYN: 26.5,
};